import React, { useState, useEffect, useContext } from "react";
import UserContext from "../../../../services/context/userContext";
import Button from "../../../../components/_default/Button";
import Input from "../../../../components/_default/Input";
import { addDailyProgressClient } from "../../../../services/firebase/firestore/saveData";
import { getCLientById } from "../../../../services/firebase/firestore/getData";
import "./progressPopupData.scss";
import moment from "moment";

export default function ProgressPopupData({ onCancel, client_id, time, currentTime, updateData }) {
    const user = useContext(UserContext);
    localStorage.removeItem("tabIndex")
    const isAdmin = (user.admin);
    const [error, setError] = useState(false);
    const [weight, setWeight] = useState(false);
    const [bodyMass, setBodyMass] = useState(false);
    const [triceps, setTriceps] = useState(0);
    const [chest, setChest] = useState(0);
    const [hip, setHip] = useState(0);
    const [thigh, setThigh] = useState(0);
    const [belly, setBelly] = useState(0);
    const [subscapula, setSubscapula] = useState(0);
    const [midaxillary, setMidaxillary] = useState(0);
    const [bodyfat, setBodyfat] = useState(false);
    const [loading, setLoading] = useState(false);
    const [age, setAge] = useState(false);
    const [gender, setGender] = useState(false);
    const from = "coach";


    const getAge =(date) => {
        var today = new Date();
        var birthDate = new Date(date);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    useEffect(() => {
        getCLientById(client_id, (result) => {
            let date_of_birth = result.date_of_birth ? result.date_of_birth.seconds : 0;
            date_of_birth = moment.unix(result.date_of_birth.seconds).format("MM-DD-YYYY");
            setAge(getAge(date_of_birth));
            setGender(result.gender);
        })
    }, [client_id])

    useEffect(() => {
        if(updateData) {
            if(updateData.weight) {
                setWeight(updateData.weight);
            }
            if(updateData.bodyMass) {
                setBodyMass(updateData.bodyMass);
            }
            if(updateData.chest) {
                setChest(updateData.chest);
            }
            if(updateData.belly) {
                setBelly(updateData.belly);
            }
            if(updateData.thigh) {
                setThigh(updateData.thigh);    
            }
            if(updateData.triceps) {
                setTriceps(updateData.triceps);
            }
            if(updateData.subscapula) {
                setSubscapula(updateData.subscapula);
            }
            if(updateData.hip) {
                setHip(updateData.hip);
            }
            if(updateData.midaxillary) {
                setMidaxillary(updateData.midaxillary);
            }
            if(updateData.bodyfat) {
                setBodyfat(updateData.bodyfat);
            }
        }
    }, [updateData, time])

    const foldData = (data) => {
        if(data) {
            if(data.fold == 'weight') {
                setWeight(data.value);
            }
            if(data.fold == 'bodyMass') {
                setBodyMass(data.value);
            }
            if(data.fold == 'chest') {
                setChest(data.value);
            }
            if(data.fold == 'belly') {
                setBelly(data.value);
            }
            if(data.fold == 'thigh') {
                setThigh(data.value);
            }
            if(data.fold == 'triceps') {
                setTriceps(data.value);
            }
            if(data.fold == 'subscapula') {
                setSubscapula(data.value);
            }
            if(data.fold == 'hip') {
                setHip(data.value);
            }
            if(data.fold == 'midaxillary') {
                setMidaxillary(data.value);
            }
            let s = parseInt(chest) + parseInt(belly) + parseInt(thigh) + parseInt(triceps) + parseInt(subscapula) + parseInt(hip) + parseInt(midaxillary);
            if (gender === "Male") {
                let bodyFatM = 495/(1.112 - (0.00043499 * s) + (0.00000055 * (s*s)) - (0.00028826 * age)) - 450;
                setBodyfat(bodyFatM.toFixed(2));
            }else {
                let bodyFatF = 495/(1.097 - (0.00046971 * s) + (0.00000056 * s*s) - (0.00012828 * age)) - 450;
                setBodyfat(bodyFatF.toFixed(2));
            }
            // if(data.fold == 'bodyfat') {
            //     setBodyfat(data.value);
            // }

        }
    }

    useEffect(() => {
        // Body density = 1.112 – (0.00043499 x sum of all the skinfolds) + (0.00000055 x sum of all of skinfolds squared) – (0.00028826 x age)
        // Body Fat Percentage (%) = [(495 / Body Density) – 450] x 100
        let s = parseFloat(chest) + parseFloat(belly) + parseFloat(thigh) + parseFloat(triceps) + parseFloat(subscapula) + parseFloat(hip) + parseFloat(midaxillary);
        if (gender === "Male") {
            let bodyFatM = 495/(1.112 - (0.00043499 * s) + (0.00000055*s*s) - (0.00028826 * age)) - 450;
            setBodyfat(bodyFatM.toFixed(2));
        }else {
            let bodyFatF = 495/(1.097 - (0.00046971 * s) + (0.00000056*s*s) - (0.00012828 * age)) - 450;
            setBodyfat(bodyFatF.toFixed(2));
        }
        let __weight = parseInt(weight*100)/100;
        let __bodyper = parseInt(bodyfat*100)/100
        setBodyMass(parseInt((__weight-(__weight/100*__bodyper))*100)/100);

    }, [chest, belly, thigh, triceps, subscapula, hip, midaxillary, age, gender]);

    function onSubmit() { 
        /*if (!document.querySelector(".c-input-bodyweight").value) {
            setError({ type: "bodyWeight", message: "Please enter your bodyweight." });
        } else if (!document.querySelector(".c-input-bodymass").value) {
            setError({ type: "bodyMass", message: "Please enter your bodymass." });
        } else if (!document.querySelector(".c-input-chest").value) {
            setError({ type: "chest", message: "Please enter your chest measurements."});
        } else if (!document.querySelector('.c-input-belly').value) {
            setError({ type: "belly", message: "Please enter your belly measurements"})
        } else if (!document.querySelector(".c-input-thigh").value) {
            setError({ type: "thigh", message: "Please enter your thighs measurements."});
        } else if (!document.querySelector(".c-input-triceps").value) {
            setError({ type: "triceps", message: "Please enter your triceps measurements."});
        } else if (!document.querySelector('.c-input-subscapula').value) {
            setError({ type: "subscapula", message: "Please enter your subscapula measurements." })
        } else if (!document.querySelector('.c-input-hip').value) {
            setError({ type: "hip", message: "Please enter your hip measurements"})
        } else if (!document.querySelector('.c-input-midaxillary').value) {
            setError({ type: "midaxillary", message: "Please enter your midaxillary measurements"})
        } else if (!document.querySelector('.c-input-bodyfat').value) {
            setError({ type:'bodyfat', message: "Please enter your bodyfat measurements"});
        } else { */
            let measurementsContent = {
                "bodyWeight": weight,
                "bodyMass": bodyMass,
                "chest": chest,
                "belly": belly,
                "thigh": thigh, 
                "triceps": triceps,
                "subscapula": subscapula, 
                "hip": hip, 
                "midaxillary": midaxillary, 
                "bodyfat": bodyfat
            };
                
            addDailyProgressClient(client_id, measurementsContent, time, currentTime, (result) => {
                onCancel();
            })
        //}
    }

    return (
        <>
            <div className="c-page-wrapper-progressPopupData">
                <div className="c-page-main c-define-page c-page-progress">
                <div className="c-add-bodyweight-container c-add-bodyweight-container-list">
                    <div className="c-add-bodyweight-container-item">
                        <h2>Bodyweight (kilogram)</h2>           
                        <Input className="c-input-bodyweight" type="number" placeholder="Kg" label=" " value={weight? weight: ""} error={error && error.type === "bodyWeight" ? error.message : false} errorStyles={{ width: "150px" }} onChange={(e) => foldData({ fold: 'weight', value : e })}/>
                    </div>
                    <div className="c-add-bodyweight-container-item">
                        <h2>Lean Body Mass</h2><br />
                        <h3>{bodyMass? bodyMass: ""} kg</h3>
                    </div>
                </div>
                <div className="c-add-bodyweight-container-list">
                    <h1>Skinfold</h1>
                    <div className="c-add-bodyweight-container-item-list">
                        
                        <div className="c-add-bodyweight-container-item">
                            <h2>Chest</h2>
                            <Input className="c-input-chest" type="number" placeholder="mm" label=" " value={chest} error={error && error.type === "chest" ? error.message : false} errorStyles={{ width: "150px" }} onChange={(e) => {foldData({ fold: 'chest', value : e })}}/>
                        </div>
                        <div className="c-add-bodyweight-container-item">
                            <h2>Umbilical</h2>
                            <Input className="c-input-belly" type="number" placeholder="mm" label=" " value={belly} error={error && error.type === "belly" ? error.message : false} errorStyles={{ width: "150px" }} onChange={(e) => {foldData({ fold: 'belly', value : e })}}/>
                        </div>
                        <div className="c-add-bodyweight-container-item">
                            <h2>Thigh</h2>
                            <Input className="c-input-thigh" type="number" placeholder="mm" label=" " value={thigh} error={error && error.type === "thigh" ? error.message : false} errorStyles={{ width: "150px" }} onChange={(e) => foldData({ fold: 'thigh', value : e })}/>
                        </div>
                        <div className="c-add-bodyweight-container-item">
                            <h2>Tricep</h2>
                            <Input className="c-input-triceps" type="number" placeholder="mm" label=" " value={triceps} error={error && error.type === "triceps" ? error.message : false} errorStyles={{ width: "150px" }} onChange={(e) => foldData({ fold: 'triceps', value : e })}/>
                        </div>

                        <div className="c-add-bodyweight-container-item">
                            <h2>Subscapular</h2>
                            <Input className="c-input-subscapula" type="number" placeholder="mm" label=" " value={subscapula} error={error && error.type === "subscapula" ? error.message : false} errorStyles={{ width: "150px" }} onChange={(e) => foldData({ fold: 'subscapula', value : e })}/>
                        </div>
                        <div className="c-add-bodyweight-container-item">
                            <h2>Hip</h2>
                            <Input className="c-input-hip" type="number" placeholder="mm" label=" " value={hip} error={error && error.type === "hip" ? error.message : false} errorStyles={{ width: "150px" }} onChange={(e) => foldData({ fold: 'hip', value : e })}/>
                        </div>
                        <div className="c-add-bodyweight-container-item">
                            <h2>Midaxillary</h2>
                            <Input className="c-input-midaxillary" type="number" placeholder="mm" label=" " value={midaxillary} error={error && error.type === "midaxillary" ? error.message : false} errorStyles={{ width: "150px" }} onChange={(e) => foldData({ fold: 'midaxillary', value : e })}/>
                        </div>
                    </div>

                    <div className="c-add-bodyweight-container-item--result">
                        <h1>Results bodyfat</h1>
                        <Input className="c-input-bodyfat" type="number" placeholder="%" label=" " value={bodyfat} error={error && error.type === "bodyfat" ? error.message : false} errorStyles={{ width: "150px" }} onChange={(e) => foldData({ fold: 'bodyfat', value : e })}/>
                        
                    </div>

                </div>
                <div className="c-button-collection c-button-collection-largePopup" style={{paddingBottom: "50px"}}>
                    <Button text="Save" color="#fff" backgroundColor="#00BDA5" onSubmit={() => onSubmit()} loading={loading} />
                    <button className="c-cancel-btn" onClick={() => onCancel()}>
                        Cancel
                    </button>
                </div>
                </div>
            </div>
        </>
    );
}